module.exports = __webpack_public_path__ + "media/theme/icon__sale-869cd7e6.png";